var __jsx = React.createElement;
import React from "react";
var InfoCard = function InfoCard(_ref) {
  var icon = _ref.icon,
    title = _ref.title,
    subtitle = _ref.subtitle,
    description = _ref.description,
    actionIcon = _ref.actionIcon,
    _ref$actionBgColor = _ref.actionBgColor,
    actionBgColor = _ref$actionBgColor === void 0 ? "" : _ref$actionBgColor,
    onActionClick = _ref.onActionClick,
    _ref$containerClassNa = _ref.containerClassName,
    containerClassName = _ref$containerClassNa === void 0 ? "border-[1px] border-solid border-[#D6DFE9] rounded-[12px] p-2 " : _ref$containerClassNa,
    id = _ref.id;
  return /*#__PURE__*/React.createElement("div", {
    id: id || "info-card",
    className: "".concat(containerClassName, " rounded-2xl p-2")
  }, /*#__PURE__*/React.createElement("div", {
    id: "".concat(id || "info-card", "-content"),
    className: "flex items-center justify-between"
  }, /*#__PURE__*/React.createElement("img", {
    id: "".concat(id || "info-card", "-icon"),
    src: icon,
    alt: title,
    className: "w-10 h-10 object-contain"
  }), /*#__PURE__*/React.createElement("div", {
    id: "".concat(id || "info-card", "-details"),
    className: "flex-1 mx-4"
  }, /*#__PURE__*/React.createElement("p", {
    id: "".concat(id || "info-card", "-title"),
    className: "text-gray-500 text-[12px] mb-2"
  }, title), /*#__PURE__*/React.createElement("h3", {
    id: "".concat(id || "info-card", "-subtitle"),
    className: "text-[14px] md:text-xl font-bold text-gray-900 mb-1 leading-6"
  }, subtitle), /*#__PURE__*/React.createElement("p", {
    id: "".concat(id || "info-card", "-description"),
    className: "text-blue-600 text-[12px] font-medium leading-6"
  }, description)), actionIcon && /*#__PURE__*/React.createElement("div", {
    id: "".concat(id || "info-card", "-action"),
    className: "border-[1px] border-solid border-[#D6DFE9] rounded-lg w-8 h-8 md:w-10 md:h-10 ".concat(actionBgColor, " flex items-center justify-center flex-shrink-0 ").concat(onActionClick ? 'cursor-pointer' : ''),
    onClick: onActionClick
  }, actionIcon)));
};
export default InfoCard;